import { requestJson } from "@/lib/api";

export type ProductReportGroupBy = "produto" | "dia" | "cliente" | "unidade";

export interface ProductCutRow {
  cut: string | null;
  orderCount: number;
  totalQuantity: number;
  totalValue: number;
}

export interface ProductSalesRow {
  productId: string;
  productCode: number | null;
  productName: string;
  unit: string;
  orderCount: number;
  totalQuantity: number;
  totalValue: number;
  cuts: ProductCutRow[];
}

export interface ProductUnitTotal {
  unit: string;
  totalQuantity: number;
}

export interface ProductSalesGroup {
  key: string | null;
  label: string;
  orders: number;
  totalValue: number;
  products: ProductSalesRow[];
}

export interface ProductSalesReport {
  groupBy: ProductReportGroupBy;
  from: string | null;
  to: string | null;
  totalOrders: number;
  totalValue: number;
  totalsByUnit: ProductUnitTotal[];
  products: ProductSalesRow[];
  groups: ProductSalesGroup[];
}

export interface InactiveProductRow {
  productId: string;
  productCode: number | null;
  productName: string;
  category: string | null;
  lastSaleDate: string | null;
  daysSinceLastSale: number | null;
  neverSold: boolean;
}

export interface InactiveProductsReport {
  days: number;
  asOf: string;
  products: InactiveProductRow[];
}

export interface ProductReportOption {
  id: string;
  code: number | null;
  name: string;
}

export interface NamedOption {
  id: string;
  name: string;
}

export interface ProductReportOptions {
  products: ProductReportOption[];
  clients: NamedOption[];
  deliveryUnits: NamedOption[];
}

export async function fetchProductSalesReport(params: {
  from?: string;
  to?: string;
  productId?: string;
  clientId?: string;
  deliveryUnitId?: string;
  groupBy?: ProductReportGroupBy;
}): Promise<ProductSalesReport> {
  const qs = new URLSearchParams();
  if (params.from) qs.set("from", params.from);
  if (params.to) qs.set("to", params.to);
  if (params.productId) qs.set("productId", params.productId);
  if (params.clientId) qs.set("clientId", params.clientId);
  if (params.deliveryUnitId) qs.set("deliveryUnitId", params.deliveryUnitId);
  if (params.groupBy) qs.set("groupBy", params.groupBy);
  const query = qs.toString();
  return requestJson<ProductSalesReport>(`/api/v1/reports/products${query ? `?${query}` : ""}`);
}

export async function fetchInactiveProducts(params: {
  days?: number;
  productId?: string;
}): Promise<InactiveProductsReport> {
  const qs = new URLSearchParams();
  if (params.days != null) qs.set("days", String(params.days));
  if (params.productId) qs.set("productId", params.productId);
  const query = qs.toString();
  return requestJson<InactiveProductsReport>(`/api/v1/reports/products/inactive${query ? `?${query}` : ""}`);
}

export async function fetchProductReportOptions(): Promise<ProductReportOptions> {
  return requestJson<ProductReportOptions>("/api/v1/reports/products/options");
}
